import { render, staticRenderFns } from "./SaleOrders.vue?vue&type=template&id=7ba45fb9&scoped=true"
import script from "./SaleOrders.vue?vue&type=script&lang=js"
export * from "./SaleOrders.vue?vue&type=script&lang=js"
import style0 from "./SaleOrders.vue?vue&type=style&index=0&id=7ba45fb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba45fb9",
  null
  
)

export default component.exports